/**
 * Centralized React Query keys — keeps cross-page cache invalidation
 * consistent. Convention: always put filter args in the key tuple so
 * different filter permutations cache independently.
 */

export const queryKeys = {
  events: {
    weekly: (filters?: { zone_id?: string; event_type?: string; voucher_tier?: string; day?: string }) =>
      ['events', 'weekly', filters || {}] as const,
    zones: () => ['events', 'zones'] as const,
    recommended: () => ['events', 'recommended'] as const,
    detail: (eventId: string) => ['events', 'detail', eventId] as const,
  },
  loyalty: {
    myCards: () => ['loyalty', 'my-cards'] as const,
    cardDetail: (cardId: string) => ['loyalty', 'cards', cardId] as const,
  },
  notifications: {
    list: () => ['notifications', 'list'] as const,
  },
  partner: {
    analytics: () => ['partner', 'analytics'] as const,
    events: () => ['partner', 'events'] as const,
    profile: () => ['partner', 'profile'] as const,
  },
  venues: {
    publicDetail: (slug: string) => ['venues', 'public', slug] as const,
    publicEvents: (slug: string) => ['venues', 'public', slug, 'events'] as const,
    publicReviews: (slug: string) => ['venues', 'public', slug, 'reviews'] as const,
  },
} as const;
